import { ArrowRight, Buildings, Check, Plus, Ruler } from '@phosphor-icons/react';
import { TEMPLATES } from '../data/assets';
import type { RoomConfig } from '../types';
import { Modal } from './Modal';

interface LaunchModalProps {
  open: boolean;
  onClose: () => void;
  onChoose: (room: RoomConfig, name: string) => void;
  onCustom: () => void;
}

export function LaunchModal({ open, onClose, onChoose, onCustom }: LaunchModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="어떤 공간에서 시작할까요?"
      description="템플릿을 고르거나 실제 현장 크기로 공간을 직접 만드세요."
      className="launch-modal"
    >
      <div className="template-grid">
        {TEMPLATES.map((template, index) => (
          <button key={template.id} type="button" className="template-card" onClick={() => onChoose(template.room, `${template.name} 배치안`)}>
            <span className={`template-visual template-${template.id}`}>
              <span className="template-floor" />
              {template.room.wallNorth && <span className="template-wall-north" />}
              {template.room.wallWest && <span className="template-wall-west" />}
              {index === 0 && <><i /><i /><i /></>}
            </span>
            <span className="template-copy">
              <span><strong>{template.name}</strong><small>{template.size}</small></span>
              {index === 0 ? <em><Check size={12} weight="bold" /> 추천</em> : <ArrowRight size={17} />}
            </span>
          </button>
        ))}
        <button type="button" className="template-card template-custom" onClick={onCustom}>
          <span className="custom-visual"><Plus size={27} /><Ruler size={17} /></span>
          <span className="template-copy"><span><strong>직접 만들기</strong><small>바닥과 벽 설정</small></span><ArrowRight size={17} /></span>
        </button>
      </div>
      <div className="launch-tip"><Buildings size={17} /><span>나중에 오른쪽 상단의 공간 크기 버튼에서 벽과 바닥을 다시 설정할 수 있습니다.</span></div>
    </Modal>
  );
}
